"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Col_module_scss_1 = __importDefault(require("./Col.module.scss"));
const Col = ({ children, className, variation = 'bodyColumn', ...rest }) => {
    const classes = (0, classnames_1.default)(Col_module_scss_1.default.content, className);
    if (variation === 'headerColumn') {
        return ((0, jsx_runtime_1.jsx)("th", { className: classes, ...rest, children: children }));
    }
    return ((0, jsx_runtime_1.jsx)("td", { className: classes, ...rest, children: children }));
};
exports.default = Col;
